import type { AuthUser } from '../types/auth';

export const getAuthUserId = (user: AuthUser | null | undefined): string => {
  if (!user) return '';
  return user.id || user.userID || '';
};

export const getAuthUserDisplayName = (user: AuthUser | null | undefined): string => {
  if (!user) return '';
  return user.displayName || user.userName || [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || user.email || getAuthUserId(user);
};
